module.exports = __webpack_public_path__ + "6b5e15afbf012a74cffbef6406b872d5.pdf";